import { createSlice, PayloadAction, current } from "@reduxjs/toolkit";
import { DtoUserData } from "../dto/auth.dto";
import { RootState } from "./store";
import { DtoAgentStatus } from "../dto/dashboard.dto";

const defaultValue: DtoUserData = {
    loading: true,
    users: {},
    error: "",
    isAuthenticated: false,
    connected : false,
    hideNavBar : false,
    preventNavigation: false,
    agentStatus: 'offline',
    allAgentStatusDetails: [],
    allKioskStatusDetails:[],
};

export const authSlice = createSlice({
    name: "auth",
    initialState: defaultValue,
    reducers: {
        fetchingUserDetails: (state, action) => {
            let newValueState: DtoUserData = { ...state };
            newValueState.loading = action.payload;
            return newValueState;
        },
        setIsAuthenticated: (state, action: PayloadAction<boolean>) => {
            let newValueState: DtoUserData = { ...state };
            newValueState.isAuthenticated = action.payload;
            return newValueState;
        },
        setError: (state, action: PayloadAction<string>) => {
            let newValueState: DtoUserData = { ...state };
            newValueState.error = action.payload;
            return newValueState;
        },
        setUserDetails: (
            state,
            action: PayloadAction<{ [index: string]: any }>
        ) => {
            let newValueState: DtoUserData = { ...state };
            newValueState.users = {...action.payload};
            return newValueState;
        },
        setStatus: (state, action: PayloadAction<boolean>) => {
            let newValueState: DtoUserData = { ...state };
            newValueState.connected = action.payload;
            return newValueState;
        },
        setHideNavBar: (state, action: PayloadAction<boolean>) => {
            let newValueState: DtoUserData = { ...state };
            newValueState.hideNavBar = action.payload;
            return newValueState;
        },
        setPreventNavigation: (state, action: PayloadAction<boolean>) => {
            let newValueState: DtoUserData = { ...state };
            newValueState.preventNavigation = action.payload;
            return newValueState;
        },
        setAgentStatus: (state, action: PayloadAction<string>) => {
            let newValueState: DtoUserData = { ...state };
            newValueState.agentStatus = action.payload;
            return newValueState;
        },
        setAllAgentStatusDetails: (state, action: PayloadAction<DtoAgentStatus[]>) => {
            let newValueState: DtoUserData = { ...state };
            newValueState.allAgentStatusDetails = [...action.payload];
            return newValueState;
        },
        setAllKioskStatusDetails: (state, action: PayloadAction<DtoAgentStatus[]>) => {
            let newValueState: DtoUserData = { ...state };
            newValueState.allKioskStatusDetails = [...action.payload];
            return newValueState;
        },
        clearAuthSlice: (state) => {
            let newValueState: DtoUserData = { ...state };
            newValueState.loading = false;
            newValueState.users = {};
            newValueState.error = "";
            newValueState.isAuthenticated = false;
            newValueState.connected = false;
            newValueState.hideNavBar = false;
            newValueState.preventNavigation = false;
            newValueState.agentStatus = 'offline';
            newValueState.allAgentStatusDetails = [];
            newValueState.allKioskStatusDetails = [];
            return newValueState;
        },
    },
});

export const authStateValue = (state: any) => state;

export const {
    fetchingUserDetails,
    setIsAuthenticated,
    setError,
    setUserDetails,
    setStatus,
    clearAuthSlice,
    setHideNavBar,
    setAgentStatus,
    setAllAgentStatusDetails,
    setAllKioskStatusDetails,
    setPreventNavigation,
} = authSlice.actions;

export default authSlice.reducer;

export const isAuthenticated = (state: RootState) =>
    state.auth.isAuthenticated === true && state.auth.error === "";
